import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Workspace from "@/pages/Workspace";
import { Loader2 } from "lucide-react";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === undefined)
    return (
      <div className="h-screen flex items-center justify-center bg-[#0B0C10]">
        <Loader2 className="w-8 h-8 text-red-600 animate-spin" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

const LoginRoute = () => {
  const { user } = useAuth();
  if (user) return <Navigate to="/" replace />;
  return <Login />;
};

function App() {
  useEffect(() => {
    document.title = "Recipe Remedy DevHub";
    // Keep the app height in sync with the *visual* viewport so the on-screen
    // keyboard shrinks the layout (composer stays visible) instead of hiding it.
    const setH = () => {
      const h = window.visualViewport?.height || window.innerHeight;
      document.documentElement.style.setProperty("--app-height", `${h}px`);
    };
    setH();
    const vv = window.visualViewport;
    vv?.addEventListener("resize", setH);
    vv?.addEventListener("scroll", setH);
    window.addEventListener("resize", setH);
    window.addEventListener("orientationchange", setH);
    return () => {
      vv?.removeEventListener("resize", setH);
      vv?.removeEventListener("scroll", setH);
      window.removeEventListener("resize", setH);
      window.removeEventListener("orientationchange", setH);
    };
  }, []);
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginRoute />} />
            <Route
              path="/"
              element={
                <Protected>
                  <Workspace />
                </Protected>
              }
            />
          </Routes>
        </BrowserRouter>
        <Toaster
          theme="dark"
          position="bottom-center"
          toastOptions={{
            style: {
              background: "#1E2029",
              border: "1px solid #6B1D2F",
              color: "#F3F4F6",
            },
          }}
        />
      </AuthProvider>
    </div>
  );
}

export default App;
